import { call, put, takeLatest } from "redux-saga/effects";
import { setData } from "../slices/HomeSlice";
import { updateExpensesListWidget } from "../slices/expensesListsSlice";
import {
  updateSavingsSourceWidget,
  updateSavingsSource,
  deleteSavingsSource,
} from "../slices/savingsSourcesSlice";
import {
  updateExpensesListTotal,
  deleteExpensesList,
  updateExpensesList,
} from "../slices/expensesSlice";
import { setWidget } from "../slices/capitalOverviewSlice";
import { api } from "../utils/api";

function* refreshWidgetsSaga() {
  try {
    const { data: widgets } = yield call(api.getWidgets);
    yield put(setData(widgets));
    console.log("Widgets refreshed:", widgets);
  } catch (error) {
    console.error("Failed to refresh widgets", error);
  }
}

export default function* homeSaga() {
  yield takeLatest(
    [
      updateExpensesListWidget.type,
      updateSavingsSourceWidget.type,
      updateSavingsSource.type,
      deleteSavingsSource.type,
      updateExpensesListTotal.type,
      deleteExpensesList.type,
      updateExpensesList.type,
      setWidget.type,
    ],
    refreshWidgetsSaga
  );
}
